module.exports = __webpack_public_path__ + "img/docRes_e.3ccb3ffd.png";